// Generated by CoffeeScript 1.9.3
var PaddingBottom, _Length,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

_Length = require('./_Length');

module.exports = PaddingBottom = (function(superClass) {
  extend(PaddingBottom, superClass);

  function PaddingBottom() {
    return PaddingBottom.__super__.constructor.apply(this, arguments);
  }

  return PaddingBottom;

})(_Length);



//////////////////
// WEBPACK FOOTER
// ./~/renderkid/lib/renderKid/styles/rule/declarationBlock/PaddingBottom.js
// module id = 398
// module chunks = 0